import { render, staticRenderFns } from "./AccommodationPrices.vue?vue&type=template&id=19316ea6"
import script from "./AccommodationPrices.vue?vue&type=script&lang=ts"
export * from "./AccommodationPrices.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports